<template>
  <v-row>
    <v-col md="12" class="pa-0">
      <table class="width-100">
        <tr v-if="engineer.country_name">
          <td
            valign="middle"
            style="width: 180px"
            class="py-1 font-size-18 text-capitalize font-weight-500 border-bottom-dashed"
          >
            <template v-if="engineer.country_name == 'singapore'">
              Street 1
            </template>
            <template v-else>Full Address</template>
          </td>
          <td
            valign="middle"
            class="py-1 font-size-18 text-capitalize border-bottom-dashed"
          >
            <template v-if="engineer.address_line_1">{{
              engineer.address_line_1
            }}</template>
            <template v-else><em class="text-muted">no street 1</em></template>
          </td>
        </tr>
        <template v-if="engineer.country_name == 'singapore'">
          <tr>
            <td
              style="width: 180px"
              valign="middle"
              class="py-1 font-size-18 text-capitalize font-weight-500 border-bottom-dashed"
            >
              Street 2
            </td>
            <td
              valign="middle"
              class="py-1 font-size-18 text-capitalize border-bottom-dashed"
            >
              <template v-if="engineer.address_line_2">{{
                engineer.address_line_2
              }}</template>
              <template v-else
                ><em class="text-muted">no street 2</em></template
              >
            </td>
          </tr>
          <tr>
            <td
              style="width: 180px"
              valign="middle"
              class="py-1 font-size-18 text-capitalize font-weight-500 border-bottom-dashed"
            >
              Unit no.
            </td>
            <td
              valign="middle"
              class="py-1 font-size-18 text-capitalize border-bottom-dashed"
            >
              <template v-if="engineer.unit_number">{{
                engineer.unit_number
              }}</template>
              <template v-else><em class="text-muted">no unit no</em></template>
            </td>
          </tr>
          <tr>
            <td
              style="width: 180px"
              valign="middle"
              class="py-1 font-size-18 text-capitalize font-weight-500 border-bottom-dashed"
            >
              Postal Code
            </td>
            <td
              valign="middle"
              class="py-1 font-size-18 text-capitalize border-bottom-dashed"
            >
              <template v-if="engineer.postal_code">{{
                engineer.postal_code
              }}</template>
              <template v-else
                ><em class="text-muted">no postal code</em></template
              >
            </td>
          </tr>
        </template>
        <tr>
          <td
            style="width: 180px"
            valign="middle"
            class="py-1 font-size-18 text-capitalize font-weight-500 border-bottom-dashed"
          >
            Country
          </td>
          <td
            valign="middle"
            class="py-1 font-size-18 text-capitalize border-bottom-dashed"
          >
            <template v-if="engineer.country_name">{{
              engineer.country_name
            }}</template>
            <template v-else><em class="text-muted">no country</em></template>
          </td>
        </tr>
        <tr>
          <td
            style="width: 180px"
            valign="top"
            class="py-1 font-size-18 text-capitalize font-weight-500"
          >
            Zone/Location of Operation
          </td>
          <td valign="middle" class="py-1 font-size-18 text-capitalize">
            <div class="d-flex flex-wrap gap-2">
              <template v-if="engineer?.zone_territory?.length">
                <v-chip
                  v-for="(territory, index) in engineer.zone_territory"
                  :key="index"
                  color="blue"
                  small
                  outlined
                  label
                  class="ma-1 font-weight-600"
                >
                  {{ territory }}
                </v-chip>
              </template>
              <template v-else>
                <em class="text-muted">no zone territories</em>
              </template>
            </div>
          </td>
        </tr>
      </table>
    </v-col>
  </v-row>
</template>

<script>
import CommonMixin from "@/core/plugins/common-mixin";

export default {
  name: "engineer-address",
  mixins: [CommonMixin],
  props: {
    engineer: {
      type: Object,
      required: true,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      pageLoading: true,
      fieldDescriptions: [
        {
          field: "product_type",
          title: "Product Type",
          description:
            "Select if this item is a physical good or a service you're offering.",
          footer: "Note",
          footer_content:
            "Once you include this items in a transaction, you cannot change its type.",
        },
      ],
    };
  },
  computed: {
    getCountryName() {
      if (
        this.lodash.isEmpty(this.engineer) === false &&
        this.lodash.isEmpty(this.engineer.country) === false
      ) {
        return this.engineer.country.name;
      }
      return null;
    },
  },
};
</script>

<style scoped>
.width-100 td + td {
  overflow-wrap: anywhere;
}
</style>
